import RestModule from "../vue-ocom/store/RestModule";
import schema from "./schema/index";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";
import { FileSystemModule } from "../vue-ocom/filesystem/store";

var root_url = process.env.VUE_APP_ROOT_API;

const UserModule = CreateUserModule(root_url);

const JobModule = RestModule(root_url + "/api/job/", schema.Job);
const CustomerModule = RestModule(root_url + "/api/customer/", schema.Customer);
const PumpModule = RestModule(root_url + "/api/pump/", schema.Pump);
const SiteContactModule = RestModule(
  root_url + "/api/site_contact/",
  schema.SiteContact
);
const CodeJobTypeModule = RestModule(
  root_url + "/api/code_job_type/",
  schema.CodeJobType
);
const SupplierModule = RestModule(root_url + "/api/supplier/", schema.Supplier);
const JobFileModule = RestModule(root_url + "/api/job_file/", schema.JobFile);
const CodeFileTypeModule = RestModule(
  root_url + "/api/code_file_type/",
  schema.CodeFileType
);
const JobNoteModule = RestModule(root_url + "/api/job_note/", schema.JobNote);
const SupervisorModule = RestModule(
  root_url + "/api/supervisor/",
  schema.Supervisor
);
const JobAssignmentModule = RestModule(
  root_url + "/api/job_assignment/",
  schema.JobAssignment
);
const CodeAreaModule = RestModule(
  root_url + "/api/code_area/",
  schema.CodeArea
);
const EmployeeModule = RestModule(root_url + "/api/employee/", schema.Employee);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  UserModule,

  JobModule,
  CustomerModule,
  PumpModule,
  SiteContactModule,
  CodeJobTypeModule,
  SupplierModule,
  JobFileModule,
  CodeFileTypeModule,
  JobNoteModule,
  SupervisorModule,
  JobAssignmentModule,
  CodeAreaModule,
  EmployeeModule,
  //Add more modules here
  FileSystemModule,
};
